import { gql } from '@apollo/client';
import { PartnerLocationInfo } from '../fragments';

export default gql`
  query partnerLocation($id: ID) {
    partnerLocation(id: $id) {
      ...PartnerLocationInfo
    }
  }
  ${PartnerLocationInfo}
`;
